import { Radio } from 'antd';
import { useCallback, useEffect, useState } from 'react';

import type { ContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  PF,
  HAS_TASKS_RADIO_OPTIONS,
} from '@pages/Clients/NewClientsList/data/constants';
import { FilterWrapper } from '@pages/Clients/NewClientsList/ui/FilterWrapper';

export const HasTasksFilter: ContentType = ({ open, onClose, id }) => {
  const [localHasTasks, setLocalHasTasks] = useState<boolean | null>(null);
  const { filtersMap, onChangeFilterById } = useNewClientsListContext();

  const { hasTasks } = filtersMap.get(id)!;

  const onConfirm = useCallback(() => {
    if (localHasTasks === null) {
      onClose?.();
      return;
    }
    onChangeFilterById(id, 'hasTasks', localHasTasks);
    onClose?.();
  }, [localHasTasks, onChangeFilterById, onClose, id]);

  useEffect(() => {
    if (open) {
      setLocalHasTasks(hasTasks);
    } else {
      setLocalHasTasks(null);
    }
  }, [hasTasks, open]);

  return (
    <FilterWrapper onConfirm={onConfirm}>
      <Radio.Group
        value={localHasTasks}
        onChange={({ target: { value } }) => setLocalHasTasks(value)}
        options={HAS_TASKS_RADIO_OPTIONS}
        className={`${PF}__radio-group`}
      />
    </FilterWrapper>
  );
};
